/*
 * @Author: zhangsheng
 * @Date: 2023-09-15 11:05:06
 * @LastEditors: zhangsheng
 * @LastEditTime: 2023-09-25 16:45:50
 * @FilePath: \panda-index-sicermem-frontend\src\locales\en-US\index.ts
 * @Description:
 *
 * Copyright (c) 2023 by zhangsheng , All Rights Reserved.
 */
export default {
  'Index.index.076615-2': 'operating cost savings',
  'Index.index.076615-3': 'double',
  'Index.index.076615-4': 'transmembrane pressure difference',
  'Index.index.076615-5': 'flux',
  'Index.index.076615-6': 'service life',
  'Index.index.076615-7': 'high performance products',
  'Index.index.076615-8': '30 years of water treatment industry',
  'Index.index.076615-9': '60 years of research and development of ceramic materials',
  'Index.index.076615-10': '30 years of development and application of ceramic membranes',
  'Index.index.076615-11': 'customized services',
  'Index.index.076615-12': 'multi scenario application',
  'Index.index.076615-13': 'full series membrane group',
  'Index.index.076615-14': 'easy membrane selection',
  'Index.index.076615-15': 'intelligent production',
  'Index.index.076615-16': '10000 square meters dedicated factory building',
  'Index.index.076615-17': 'annual production capacity of 500000 square meters series specifications',
  'Index.index.076615-18': 'automated and continuous production line',
  'Index.index.076615-19':
    'W membrane - a new generation of inorganic membranes that make membrane separation more efficient and economical',

  'Index.index.076615-50': 'High strength',
  'Index.index.076615-51': 'High flux',
  'Index.index.076615-52': 'Pollution resistance',
  'Index.index.076615-53': 'Antioxidant',

  'Index.index.076615-21': 'W membrane',
  'Index.index.076615-22': 'Inorganic Membrane',
  'Index.index.076615-23': 'see details',
  'Index.index.076615-24': 'Compare 「organic film」',
  'Index.index.076615-25': 'Compared to 「Ceramic Membrane」',
  'Index.index.076615-26': 'the membrane area increases to',
  'Index.index.076615-27': 'backwash',
  'Index.index.076615-28': 'More efficient and thorough',
  'Index.index.076615-29': 'The longitudinal bending strength is higher than',
  'Index.index.076615-30': 'Related products',
  'Index.index.076615-31': 'W Membrane module',
  'Index.index.076615-32': 'W membrane tower',
  'Index.index.076615-33': '300㎡ W inorganic membrane module',
  'Index.index.076615-34': 'Ceramic Membrane',
  'Index.index.076615-35': 'convention',
  'Index.index.076615-36': 'New water treatment technology',
  'Index.index.076615-37': 'Large filtration area',
  'Index.index.076615-38': 'Good chemical stability',
  'Index.index.076615-39': 'Acid and alkali resistance, corrosion resistance',
  'Index.index.076615-40': 'Strong pollution resistance',
  'Index.index.076615-41': 'About Us',
  'Index.index.076615-42': 'SICERMEM',
  'Index.index.076615-43':
    'Shanghai Siyuan Membrane Technology Co., Ltd. originated from Shandong Silicate Research and Design Institute established in 1958 and was recognized as a national high-tech enterprise by the Shanghai Municipal Science and Technology Commission in 2020.',
  'Index.index.076615-44':
    'After more than 60 years of accumulation, it has developed into a leading research, development, and production base for inorganic membrane materials at home and abroad, integrating W inorganic membrane and conventional flat ceramic membrane.',
  'Index.index.076615-45':
    'Shanghai Silicon Garden Membrane has comprehensively improved the core technology of ceramic membranes and achieved sustainable development through cooperation with renowned domestic and foreign universities, research institutions, and large water companies such as Olburg University and Tongji University in Denmark. It can provide customized inorganic membrane products for partners.',
  'Index.index.076615-46': 'More',
  'Index.index.076615-47': 'Our Advantages',
  'Index.index.076615-48':
    'After more than 60 years of accumulation, it has developed into a leading research, development, and production base for inorganic membrane materials at home and abroad, integrating W inorganic membrane and conventional flat ceramic membrane.',

  'Index.index.076615-49': '/en/searchConsult',
  'Index.index.076615-54': 'Flat Ceramic Membrane (Common)',
};
